import React from 'react';
import styles from './Notification.scss';

export const Spinner = () => <div className={styles.spinner} />;
